import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import UiButton from '@/ui/UiButton/UiButton';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="page">
      <div className="article article-error">
        <h1 className="article-title">Страница не найдена</h1>
        <UiButton
          className="article-action"
          onClick={() => navigate('/')}
        >
          На главную
        </UiButton>
      </div>
    </div>
  );
}
